export default function getCartItemsIncompleteSerials(cartItems = []) {
  return cartItems.filter(cartItem => {
    const serials = cartItem.serial_numbers || []
    const validSerials = serials.filter(serial => !!serial)

    return cartItem.requires_serial && validSerials.length !== cartItem.quantity
  })
}
